/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateAdditionalDataRequest } from "../types/UpdateAdditionalDataRequest.ts";
import { eAcademicEducationSchema } from "./eAcademicEducationSchema.ts";
import { eColorSkinSchema } from "./eColorSkinSchema.ts";
import { eExperienceLevelSchema } from "./eExperienceLevelSchema.ts";
import { eServiceTimeSchema } from "./eServiceTimeSchema.ts";

export const updateAdditionalDataRequestSchema = z.object({
  profession: z
    .string()
    .describe("Nome da profissão da pessoa (texto livre). Opcional.")
    .nullish(),
  professionId: z
    .number()
    .int()
    .describe("ID da profissão associada à pessoa. Opcional.")
    .nullish(),
  company: z
    .string()
    .describe("Nome da empresa onde a pessoa trabalha (texto livre). Opcional.")
    .nullish(),
  otherCompanyName: z
    .string()
    .describe(
      "Nome de empresa não listada informado manualmente pela pessoa. Opcional.",
    )
    .nullish(),
  associatedCompanyId: z
    .number()
    .int()
    .describe("ID da empresa associada à pessoa. Opcional.")
    .nullish(),
  academicEducation: z.optional(
    z
      .lazy(() => eAcademicEducationSchema)
      .describe(
        "1 = UndergraduateDegree | 2 = Technologist | 3 = PostgraduateDegree | 4 = MasterDegree | 5 = DoctorateDegree | 6 = BachelorDegree | 7 = HighSchool | 8 = Specialist | ",
      ),
  ),
  academicInstitutionId: z
    .number()
    .int()
    .describe("ID da instituição de ensino associada à pessoa. Opcional.")
    .nullish(),
  otherAcademicInstitution: z
    .string()
    .describe(
      "Nome de instituição de ensino não listada informado manualmente pela pessoa. Opcional.",
    )
    .nullish(),
  academicCourseName: z
    .string()
    .describe("Nome do curso acadêmico da pessoa. Opcional.")
    .nullish(),
  completionDate: z
    .string()
    .datetime()
    .describe("Data de conclusão do curso acadêmico. Opcional.")
    .nullish(),
  jobPositionId: z
    .number()
    .int()
    .describe("ID do cargo profissional associado à pessoa. Opcional.")
    .nullish(),
  otherJobPosition: z
    .string()
    .describe(
      "Descrição de cargo profissional não listado (texto livre). Opcional.",
    )
    .nullish(),
  businessSectorId: z
    .number()
    .int()
    .describe("ID do setor de atuação associado à pessoa. Opcional.")
    .nullish(),
  otherBusinessSector: z
    .string()
    .describe(
      "Descrição de setor de atuação não listado (texto livre). Opcional.",
    )
    .nullish(),
  serviceTime: z.optional(
    z
      .lazy(() => eServiceTimeSchema)
      .describe(
        "1 = UpTo1Year | 2 = OneToThreeYears | 3 = ThreeToFiveYears | 4 = MoreThanFiveYears | 5 = NotApplicable | ",
      ),
  ),
  experienceLevel: z.optional(
    z
      .lazy(() => eExperienceLevelSchema)
      .describe(
        "1 = Junior | 2 = MidLevel | 3 = Senior | 4 = NotApplicable | ",
      ),
  ),
  selfEmployed: z
    .boolean()
    .describe("Indica se a pessoa é autônoma. Opcional.")
    .nullish(),
  isWorking: z
    .boolean()
    .describe("Indica se a pessoa está atualmente empregada. Opcional.")
    .nullish(),
  miniCurriculum: z
    .string()
    .describe("Mini currículo ou resumo profissional da pessoa. Opcional.")
    .nullish(),
  urlLinkedin: z
    .string()
    .describe("URL do perfil do LinkedIn da pessoa. Opcional.")
    .nullish(),
  urlLattes: z
    .string()
    .describe("URL do currículo Lattes da pessoa. Opcional.")
    .nullish(),
  observation: z
    .string()
    .describe("Observações gerais sobre a pessoa. Opcional.")
    .nullish(),
  isPCD: z
    .boolean()
    .describe("Indica se a pessoa é portadora de deficiência (PCD). Opcional.")
    .nullish(),
  pcdDescription: z
    .string()
    .describe("Descrição da deficiência da pessoa. Opcional.")
    .nullish(),
  useAccessibilityTool: z
    .boolean()
    .describe(
      "Indica se a pessoa utiliza alguma ferramenta de acessibilidade. Opcional.",
    )
    .nullish(),
  accessibilityToolDescription: z
    .string()
    .describe(
      "Descrição da ferramenta de acessibilidade utilizada pela pessoa. Opcional.",
    )
    .nullish(),
  colorSkin: z.optional(
    z
      .lazy(() => eColorSkinSchema)
      .describe(
        "1 = White | 2 = Black | 3 = BrownMixed | 4 = Yellow | 5 = Indigenous | 6 = NoInformationAvailable | 7 = NoDeclare | ",
      ),
  ),
}) as unknown as ToZod<UpdateAdditionalDataRequest>;
